export enum DataTypeEnum {
    String = 0,
    Integer = 1,
    Double = 2,
    Decimal = 3,
    Boolean = 4,
    DateTime = 5,
    Guid = 6,
    Float = 7,
    DateOnly = 8,
    Long = 9
}
